import actionTypes from '../constants/action-types';
import globals from '../../globals';
import DEFAULT_OPTIONS from '../constants/default-options';

const setInlineElementStyle = (elementId, propertyName, value, options = DEFAULT_OPTIONS) =>
  globals.helpers.globalActionExtender({
    type: actionTypes.SET_INLINE_ELEMENT_STYLE,
    payload: {
      elementId,
      propertyName,
      value,
      options,
    },
  });

export default setInlineElementStyle;
